import { render, staticRenderFns } from "./FabricFilter.vue?vue&type=template&id=d8f97130&"
import script from "./FabricFilter.vue?vue&type=script&lang=ts&"
export * from "./FabricFilter.vue?vue&type=script&lang=ts&"
import style0 from "./FabricFilter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports